import React, { useState } from "react";
import InfoTip from "../../../../utils/InfoTip";
import { getAssigneeId } from "../../../../utils/useCandidateAccess";
import { initialsOf } from "../constants";
import ModalShell from "./ModalShell";

// Assign / reassign a candidate (admins & full candidate access only).
// `onSave(companyUserId | null)` must resolve to true on success so the modal can stay open on failure.
const AssignCandidateModal = ({ candidate, members, onSave, onClose }) => {
  const [value, setValue] = useState(getAssigneeId(candidate) || "");
  const [search, setSearch] = useState("");
  const [saving, setSaving] = useState(false);

  const query = search.trim().toLowerCase();
  const filteredMembers = query
    ? members.filter((m) => String(m.name || "").toLowerCase().includes(query))
    : members;

  const save = async (companyUserId) => {
    setSaving(true);
    const ok = await onSave(companyUserId);
    if (!ok) setSaving(false);
  };

  return (
    <ModalShell
      title={<>Assign candidate<InfoTip text="The assigned team member can open this candidate, change status and assign stages. Only admins and members with full candidate access can change assignments." /></>}
      titleStyle={{ display: "flex", alignItems: "center" }}
      maxWidth={420}
      onClose={onClose}
    >
      <div className="jv2-modal-body">
        <p style={{ textAlign: "left", fontSize: 13, color: "#525b66", margin: "0 0 12px" }}>
          Candidate: <strong>{candidate?.name || "—"}</strong>
        </p>
        <label className="save-search-field-label">Assign to</label>
        <input
          type="text"
          className="save-search-name-input"
          placeholder="Search team member…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="assign-member-list-v2">
          {filteredMembers.length === 0 ? (
            <div className="assign-member-empty-v2">No team members found</div>
          ) : (
            filteredMembers.map((m) => {
              const selected = String(value) === String(m.id);
              return (
                <button
                  type="button"
                  key={m.id}
                  className={`assign-member-item-v2${selected ? " selected" : ""}`}
                  onClick={() => setValue(m.id)}
                >
                  <span className="assignee-avatar-v2">{initialsOf(m.name)}</span>
                  <span className="assign-member-name-v2">{m.name}</span>
                  {selected && <span className="assign-member-check-v2">✓</span>}
                </button>
              );
            })
          )}
        </div>
      </div>
      <div className="jv2-modal-footer">
        {getAssigneeId(candidate) && (
          <button
            className="jv2-modal-cancel"
            style={{ color: "#DC2626", marginRight: "auto" }}
            disabled={saving}
            onClick={() => save(null)}
          >
            Remove assignment
          </button>
        )}
        <button className="jv2-modal-cancel" onClick={onClose}>Cancel</button>
        <button className="jv2-modal-confirm" disabled={!value || saving} onClick={() => save(value)}>
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </ModalShell>
  );
};

export default AssignCandidateModal;
